<top-banner variant="title" title="Outage Acceptance List"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">

      <ng-container *ngFor="let trainingCourses of groupedTrainingCourses">
        <div class="card training-section-card-group">
          <ng-container *ngFor="let course of trainingCourses">
            <div class="card-body d-flex align-items-center training-section-card">
              <span style="flex: 1" *ngIf="course.expiryDate"><i class="fas fa-check-circle success"></i></span>
              <span style="flex: 1" *ngIf="!course.expiryDate"><i class="fas fa-times-circle danger"></i></span>

              <div style="flex: 6">{{course.course.trainingName}}</div>
              <div style="flex: 4" *ngIf="course.expiryDate">Accepted On: {{course.lastModifiedDate | date: 'yyyy-MM-dd'}}</div>
              <div style="flex: 4" *ngIf="!course.expiryDate"></div>

              <div style="flex: 1" *ngIf="!course.hasOneInProgress && course.courseProgress === TrainingCourseStateType.Completed">
                <a class="btn btn-success btn-round" [routerLink]="['/', routeRole, 'outage-acceptance', course.userCourseId]" [queryParams]="{type: 'contractor',view: 'review'}">review</a>
              </div>
              <div style="flex: 1" *ngIf="!course.hasOneInProgress && course.courseProgress === TrainingCourseStateType.Expired">
                <span class="badge badge-pill badge-success">Completed - Inactive</span>
              </div>
              <div style="flex: 1" *ngIf="course.courseProgress === TrainingCourseStateType.NotStarted">
                <a class="btn btn-success btn-round" [routerLink]="['/', routeRole, 'outage-acceptance', course.userCourseId]" [queryParams]="{type: 'contractor'}">start</a>
              </div>
              <div style="flex: 1" *ngIf="course.courseProgress === TrainingCourseStateType.InProgress">
                <a class="btn btn-success btn-round" [routerLink]="['/', routeRole, 'outage-acceptance', course.userCourseId]" [queryParams]="{type: 'contractor'}">continue</a>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
